import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enMenu from './locales/en/menu.json';
import enAuth from './locales/en/auth.json';
import enContracts from './locales/en/contracts.json';
import enDashboard from './locales/en/dashboard.json';
import enInvoices from './locales/en/invoices.json';
import enProjects from './locales/en/projects.json';
import enCustomers from './locales/en/customers.json';
import enRentals from './locales/en/rentals.json';
import enWarehouses from './locales/en/warehouses.json';
import enCrew from './locales/en/crew.json';
import enTasks from './locales/en/tasks.json';
import enOffers from './locales/en/offers.json';
import enComponents from './locales/en/components.json';
import enTransport from './locales/en/transport.json';
import enCalendar from './locales/en/calendar.json';
import enStatistics from './locales/en/statistics.json';
import enNotifications from './locales/en/notifications.json';
import enProfile from './locales/en/profile.json';
import enSettings from './locales/en/settings.json';
import enAssistant from './locales/en/assistant.json';
import enChat from './locales/en/chat.json';
import enSidebar from './locales/en/sidebar.json';
import enSupport from './locales/en/support.json';

// Import Czech translations
import csCommon from './locales/cs/common.json';
import csMenu from './locales/cs/menu.json';
import csAuth from './locales/cs/auth.json';
import csContracts from './locales/cs/contracts.json';
import csDashboard from './locales/cs/dashboard.json';
import csInvoices from './locales/cs/invoices.json';
import csProjects from './locales/cs/projects.json';
import csCustomers from './locales/cs/customers.json';
import csRentals from './locales/cs/rentals.json';
import csWarehouses from './locales/cs/warehouses.json';
import csCrew from './locales/cs/crew.json';
import csTasks from './locales/cs/tasks.json';
import csOffers from './locales/cs/offers.json';
import csComponents from './locales/cs/components.json';
import csTransport from './locales/cs/transport.json';
import csCalendar from './locales/cs/calendar.json';
import csStatistics from './locales/cs/statistics.json';
import csNotifications from './locales/cs/notifications.json';
import csProfile from './locales/cs/profile.json';
import csSettings from './locales/cs/settings.json';
import csAssistant from './locales/cs/assistant.json';
import csChat from './locales/cs/chat.json';
import csSidebar from './locales/cs/sidebar.json';
import csSupport from './locales/cs/support.json';

// Merge all translation sections into the expected structure
const resources = {
  en: {
    translation: {
      common: enCommon,
      menu: enMenu,
      auth: enAuth,
      contracts: enContracts,
      dashboard: enDashboard,
      invoices: enInvoices,
      projects: enProjects,
      customers: enCustomers,
      rentals: enRentals,
      warehouses: enWarehouses,
      // Tasks, offers, and other shared components
      tasks: enTasks,
      offers: enOffers,
      components: enComponents,
      transport: enTransport,
      crew: enCrew,
      calendar: enCalendar,
      statistics: enStatistics,
      notifications: enNotifications,
      profile: enProfile,
      settings: enSettings,
      assistant: enAssistant,
      chat: enChat,
      sidebar: enSidebar,
      support: enSupport
    }
  },
  cs: {
    translation: {
      common: csCommon,
      menu: csMenu,
      auth: csAuth,
      contracts: csContracts,
      dashboard: csDashboard,
      invoices: csInvoices,
      projects: csProjects,
      customers: csCustomers,
      rentals: csRentals,
      warehouses: csWarehouses,
      // Tasks, offers, and other shared components
      tasks: csTasks,
      offers: csOffers,
      components: csComponents,
      transport: csTransport,
      crew: csCrew,
      calendar: csCalendar,
      statistics: csStatistics,
      notifications: csNotifications,
      profile: csProfile,
      settings: csSettings,
      assistant: csAssistant,
      chat: csChat,
      sidebar: csSidebar,
      support: csSupport
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    }
  });

export default i18n;
